import { NAV_EXPERIENCE_PATH_SERVICE } from './paths';
import { getUserIsLoggendin } from 'containers/User/service';
import { module_version } from '../content/module_version';
import { apiCall } from 'api';
import { transformUrlPath } from 'api/helpers/utils/transformPath';
import { getUserToken } from 'utils/user/getUserToken';

export const navExperienceService = async (params = {}) => {
  if (!getUserToken()) {
    await getUserIsLoggendin();
  }
  const user_token = getUserToken();
  apiCall.defaults.headers['Authorization'] = `Bearer ${user_token}`;

  return apiCall?.get(transformUrlPath(NAV_EXPERIENCE_PATH_SERVICE), {
    params: {
      module_version,
      user_token: null,
      ...params,
    },
  });
};
